import { FC } from 'react'
import {
  useForm,
  FormProvider,
  FormProviderProps,
  useFormContext,
  UseFormOptions,
} from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers'
import { StaplesLaneModalSchema, TStaplesLaneModalSchema } from '../schema/StaplesLaneModalSchema'

const getDefaultValues = (defaultValues: Partial<TStaplesLaneModalSchema> = {}) => ({
  ...StaplesLaneModalSchema.cast(defaultValues),
})

/**
 * "This form is used for Staples Headhaul Lane related forms (i.e add, edit)"
 */

export const useStaplesForm = (props: Omit<UseFormOptions, 'resolver' | 'mode'>) => {
  const { defaultValues = {} } = props || {}
  return useForm<TStaplesLaneModalSchema>({
    resolver: yupResolver(StaplesLaneModalSchema),
    mode: 'onChange',
    defaultValues: {
      ...getDefaultValues(defaultValues),
    },
  })
}

export const StaplesFormProvider: FC<FormProviderProps<TStaplesLaneModalSchema>> = FormProvider

export const useStaplesFormContext = () => useFormContext<TStaplesLaneModalSchema>()
